import type { ModuleContribution } from '@ochal/module-sdk/contracts';

interface OwnedContribution { owner: string; definition: ModuleContribution; loaded?: unknown; loading?: Promise<unknown> }
export class ContributionRegistry {
  private readonly contributions = new Map<string, OwnedContribution>();
  register(owner: string, definitions: readonly ModuleContribution[]): void {
    const next = new Set<string>();
    const routePaths = new Set(this.list('route').map((definition) => (definition as { path?: string }).path));
    for (const definition of definitions) {
      if (this.contributions.has(definition.id) || next.has(definition.id)) throw new Error(`Duplicate contribution: ${definition.id}`);
      if (definition.kind === 'route') { const path = (definition as { path: string }).path; if (routePaths.has(path)) throw new Error(`Duplicate route path: ${path}`); routePaths.add(path); }
      next.add(definition.id);
    }
    for (const definition of definitions) this.contributions.set(definition.id, { owner, definition: Object.freeze({ ...definition }) as ModuleContribution });
  }
  unregisterOwner(owner: string): void { for (const [id, value] of this.contributions) if (value.owner === owner) this.contributions.delete(id); }
  list(kind?: ModuleContribution['kind']): readonly ModuleContribution[] { return [...this.contributions.values()].filter((value) => !kind || value.definition.kind === kind).map((value) => value.definition).sort((a, b) => (a.order ?? 0) - (b.order ?? 0)); }
  ownerOf(id: string): string | undefined { return this.contributions.get(id)?.owner; }
  async load(id: string): Promise<unknown> {
    const contribution = this.contributions.get(id);
    if (!contribution) throw new Error(`Contribution not registered: ${id}`);
    if ('loaded' in contribution) return contribution.loaded;
    contribution.loading ??= contribution.definition.load();
    try { contribution.loaded = await contribution.loading; return contribution.loaded; } finally { contribution.loading = undefined; }
  }
}
